import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {action} from 'redux/helpers';
import {IDiplomatObject} from 'types/DiplomatObject';
import {settingsTypes} from '..';

export const useDeleteAdminRole = () => {
   const dispatch = useDispatch();
   const onDelete = useCallback(
      (roles: IDiplomatObject[]) => {
         dispatch(action(settingsTypes.DELETE_ADMIN_ROLE.SAGA, roles));
      },
      [dispatch]
   );

   return onDelete;
};
